import './style/index.less';
import ExemptTrialImportPanel from './ExemptTrialImportPanel';

export default ExemptTrialImportPanel;
